module.exports = [{
  plugin: require('../../@mdx-deck/gatsby-plugin/gatsby-browser.js'),
  options: {
    "plugins": [],
    "path": "/vercel/path0/deck.mdx",
    "dirname": "/vercel/path0"
  }
}];